// extracted by mini-css-extract-plugin
export default {"cell":"cell_cell__8Gy9w","cellNoLine":"cell_cellNoLine__gqYyk","cellNoPadding":"cell_cellNoPadding__YUZQB"};